import { useState, useEffect } from 'react';

import { SH_SESSION_START } from '@/utils/springHealthUtils';

export const SESSION_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes
const CHECK_INTERVAL_MS = 10 * 1000; // 10 seconds

const checkExpiration = (): boolean => {
  const sessionStart = sessionStorage.getItem(SH_SESSION_START);
  if (!sessionStart) {
    return false;
  }
  return Date.now() - Number(sessionStart) >= SESSION_TIMEOUT_MS;
};

const useSessionTimeout = (): { isExpired: boolean } => {
  const [isExpired, setIsExpired] = useState(() => checkExpiration());

  useEffect(() => {
    if (isExpired) {
      return undefined;
    }

    const intervalId = setInterval(() => {
      if (checkExpiration()) {
        setIsExpired(true);
      }
    }, CHECK_INTERVAL_MS);

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && checkExpiration()) {
        setIsExpired(true);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(intervalId);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isExpired]);

  return { isExpired };
};

export default useSessionTimeout;
